// extracted by mini-css-extract-plugin
export var navbarSubLink = "F_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "F_tN d_f0 d_dB";
export var subPageLink = "F_gf d_gf";
export var burger = "F_vY";
export var sublinkSize = "F_vZ";
export var linkSize = "F_v0";
export var Link = "F_rv s_rv s_qM s_q5";